import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Html from 'partials/Html';
import Media from 'css/Media';

class VideoModule extends Component {
    
    render() {
        const { data, prevModule } = this.props;
        return (
            <ModuleWrapper 
                bleed={data.bleed || !data.toggle_size} 
                bigger={!data.toggle_size}
                prevModule={prevModule}
            >
                <Container 
                    grid 
                    bleed={data.bleed} 
                    mobileBleed={!data.toggle_size}
                >
                    <GridElement
                        colStart={{default: 1,s: data.bleed ? 1 : !data.toggle_size ? 3 : 5}}
                        colEnd={{default: 8, s: data.bleed ? 24 : !data.toggle_size ? 22 : 20}}
                    >
                        <StyledHtml content>{data.video}</StyledHtml>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default VideoModule;

const ModuleWrapper = styled.div`
   ${props => props.prevModule === 'rich_text' && css`
        margin: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementXS};
        
        ${props => props.bleed && css`
            margin: ${props => props.theme.spacing.elementM} 0 ${props => props.theme.spacing.elementM};
        `}

        ${Media.greaterThan('s')`
            margin: ${props => props.theme.spacing.elementS} 0 ${props => props.theme.spacing.elementM};
            
            ${props => props.bleed && css`
                margin: ${props => props.theme.spacing.blockXS} 0 ${props => props.theme.spacing.blockXS};
            `}
        `}

        ${Media.greaterThan('l')`
            margin: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.elementXL};
            
            ${props => props.bleed && css`
                margin: ${props => props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockXS};
            `}
        `}
    `}

    ${props => props.prevModule !== 'rich_text' && css`
        margin: ${props => props.theme.spacing.elementXS} 0 ${props => props.theme.spacing.elementXS};
        
        ${props => props.bleed && css`
            margin: ${props => props.theme.spacing.elementM} 0 ${props => props.theme.spacing.elementM};
        `}

        ${Media.greaterThan('s')`
            margin: ${props => props.theme.spacing.blockXS} 0 ${props => props.theme.spacing.blockXS};
        `}

        ${Media.greaterThan('l')`
            margin: ${props => props.theme.spacing.blockL} 0 ${props => props.theme.spacing.blockXS};
            
            ${props => props.bleed && css`
                margin: ${props => props.theme.spacing.blockM} 0 ${props => props.theme.spacing.blockXS};
            `}
        `}
    `}
`

const StyledHtml = styled(Html)`
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`
